import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHot$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHot extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'add66dbd3de5814e8e3b49ad0a2759152340587c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '11594de78b31ea81c73c32268aac58344a1acc46', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'beb9e481cad3801caac88953bc7357421ee1d255', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.5 18.481c.074.033.16.022.224-.028A8.49 8.49 0 0 0 17 11.993a5.63 5.63 0 0 0-1.653-4.173.2.2 0 0 0-.327.1 4.2 4.2 0 0 1-1.643 2.364 8.2 8.2 0 0 0 .206-2.01 6.07 6.07 0 0 0-2.567-5.243.208.208 0 0 0-.312.117c-.504 1.666-1.032 2.43-2.987 4.461C5.72 9.682 5 11.107 5 12.986a5.2 5.2 0 0 0 4.234 5.1.2.2 0 0 0 .177-.311 5.6 5.6 0 0 1-.85-2.8 3.26 3.26 0 0 1 .659-2.03c.202 2.466 1.624 4.305 4.28 5.536", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-hot", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-hot"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-hot":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHot$1);
            }
            break;
    } });
}

const CosmosIconHot = CosmosIconHot$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHot, defineCustomElement };
